import { CALL_API } from "../api.middleware";
import {
  GET_FUNDS_LIST_PAN,
  GET_FUNDS_LIST_PAN_SUCCESS,
  GET_FUNDS_LIST_PAN_FAILED,
  GET_TRANSACTION_HISTORY,
  GET_TRANSACTION_HISTORY_SUCCESS,
  GET_TRANSACTION_HISTORY_FAILED,
  GET_NAV_DATA,
  GET_NAV_DATA_SUCCESS,
  GET_NAV_DATA_FAILED,
  REMOVE_TRANSACTION_HISTORY_DATA,
  REMOVE_NAV_DATA
} from "../types";

export const getFundsByPan = params => async dispatch => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetFundslistByPAN",
        params,
        types: [
          GET_FUNDS_LIST_PAN,
          GET_FUNDS_LIST_PAN_SUCCESS,
          GET_FUNDS_LIST_PAN_FAILED
        ],
        method: "GET"
      }
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getTransactionHistory = params => async dispatch => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetTrxnDatabyFund",
        params,
        types: [
          GET_TRANSACTION_HISTORY,
          GET_TRANSACTION_HISTORY_SUCCESS,
          GET_TRANSACTION_HISTORY_FAILED
        ],
        method: "GET"
      }
    });
  } catch (error) {
    alert(`${error}`);
  }
};



export const getNavData = params => async dispatch => {
  try {
    await dispatch({
      [CALL_API]: {
        url: "/GetNAVGraph",
        params,
        method: "GET",
        types: [GET_NAV_DATA, GET_NAV_DATA_SUCCESS, GET_NAV_DATA_FAILED]
      }
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const removeNavData = () => {
  return {
    type: REMOVE_NAV_DATA
  };
};

export const RemoveTransactionData = () => {
  return {
    type: REMOVE_TRANSACTION_HISTORY_DATA
  };
};
